import { Loader2 } from "lucide-react";
import type { IComparisonSummary } from "src/@types/campaign-comparison";

interface ComparisonSummaryCardsProps {
  summary: IComparisonSummary;
  progress?: { processed: number; total: number } | null;
}

interface KpiCardProps {
  label: string;
  value: number;
  sublabel?: string;
  valueClassName?: string;
}

function KpiCard({ label, value, sublabel, valueClassName }: KpiCardProps) {
  return (
    <div className="rounded-lg border bg-card p-4">
      <div className="text-sm font-medium text-muted-foreground">{label}</div>
      <div className={`text-2xl font-bold ${valueClassName || ""}`}>
        {value}
      </div>
      {sublabel && (
        <div className="text-xs text-muted-foreground">{sublabel}</div>
      )}
    </div>
  );
}

export function ComparisonSummaryCards({
  summary,
  progress,
}: ComparisonSummaryCardsProps) {
  const isRunning = !!progress && progress.processed < progress.total;
  const pageLabel = isRunning
    ? `comparadas ${progress.processed}/${progress.total}`
    : `nesta página (${summary.pageStores})`;
  const percent =
    progress && progress.total
      ? Math.round((progress.processed / progress.total) * 100)
      : 0;

  return (
    <div className="space-y-2">
      {isRunning && (
        <div className="space-y-1">
          <div className="flex items-center justify-between text-sm">
            <span className="inline-flex items-center gap-1.5 font-medium text-muted-foreground">
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
              Comparando lojas…
            </span>
            <span className="font-mono text-muted-foreground">
              {progress.processed}/{progress.total}
            </span>
          </div>
          <div className="h-1.5 w-full overflow-hidden rounded-full bg-muted">
            <div
              className="h-full bg-primary transition-all duration-300"
              style={{ width: `${percent}%` }}
            />
          </div>
        </div>
      )}
      <div className="grid gap-4 md:grid-cols-5">
        <KpiCard
          label="Total de Lojas"
          value={summary.totalStores}
          sublabel="participantes"
        />
        <KpiCard
          label="Sincronizadas"
          value={summary.synced}
          sublabel={pageLabel}
          valueClassName="text-green-500"
        />
        <KpiCard
          label="Divergentes"
          value={summary.divergent}
          sublabel={pageLabel}
          valueClassName="text-yellow-500"
        />
        <KpiCard
          label="Não encontradas"
          value={summary.notFoundInStore}
          sublabel={pageLabel}
          valueClassName="text-red-500"
        />
        <KpiCard
          label="Inacessíveis"
          value={summary.unreachable}
          sublabel={pageLabel}
          valueClassName="text-muted-foreground"
        />
      </div>
    </div>
  );
}
